import React, { ReactNode } from 'react'

type SpinnerProp = {
  loading?: boolean | undefined,
  children?: ReactNode | undefined,
  mask?: boolean | undefined,
  hideicon?: boolean | undefined,
  transparent?: boolean | undefined,
  style?: any,
}

const Spinner = (props: SpinnerProp) => {
  let {loading, children, mask, ...spinner} = props

  let style: {[key:string]:any} = {
    ...spinner.style,
    backgroundColor: undefined,
  }

  let className = 'spinner'
  if (mask) {
    className += ` mask`
  }

  if (!!spinner.transparent) {
    style.backgroundColor = 'transparent'
  }
  
  return (
    <>
    {loading && (
      <div 
        className={className}
        style={style}
      >
        <div className="spinner-content">
          { !spinner.hideicon && <span className="fa fa-spinner fa-pulse" /> }
          &nbsp;
          <span className="spinner-text">{children}</span>
        </div>
      </div>
    )}
    </>
  )
}

Spinner.defaultProps = {
  // children: (<></>),
  loading: +true,
  mask: +false,
  hideicon: false,
  transparent: +false,
  style: { }
}

export default Spinner
